import request from '@shared/api/request';
import { API_TEAMS_PATH } from '@shared/constants/pathsConstants';

export function getTeams() {
    return request.get(`/${API_TEAMS_PATH}/`);
}
